import {DestroyRef, Injectable, inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Store} from '@ngrx/store';
import {distinctUntilChanged} from 'rxjs/operators';
import {KeycloakService} from 'keycloak-angular';
import * as Sentry from '@sentry/angular';
import {selectedProfile, StoreState} from '@redux/reducers';
import {isPWAInstalled} from '@shared/util/pwa-util';

export const APP_SESSION_LOG = 'app.session';

@Injectable({
  providedIn: 'root'
})
export class UsageMetricsService {

  private readonly _window = inject(DOCUMENT).defaultView;
  private readonly _keycloak = inject(KeycloakService);
  private readonly _store = inject(Store<StoreState>);
  private readonly _destroyRef = inject(DestroyRef);

  start(): void {
    const userId = this._keycloak.getKeycloakInstance()?.subject;
    if (userId) {
      Sentry.setUser({id: userId});
    }

    this._store.pipe(
      selectedProfile,
      distinctUntilChanged((previous, current) => previous.id === current.id),
      takeUntilDestroyed(this._destroyRef)
    ).subscribe(profile => {
      Sentry.logger.info(APP_SESSION_LOG, {
        'school.id': profile.schoolId,
        'school.cabangaLite': profile.cabangaLite,
        'pwa.installed': isPWAInstalled(),
        'profile.type': profile.type,
        'user_agent.original': this._window?.navigator.userAgent
      });
    });
  }
}
